import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PermissionStates } from '../../permission-controller/root';
import { PermWizardStates } from '../states';
import { permWizardAdapters, PermWizardState } from '../states/permission-wizard.states';

export const permWizardFeatureKey = 'permWizard';

export const selectPermWizardFeature = createFeatureSelector<PermWizardState>(permWizardFeatureKey);

export const selectNewPermWizard = (state: PermissionStates) => state.permissions.permWizard.newPermWizard;
export const selectPermWizard = (state: PermissionStates) => state.permissions.permWizard.selectedPermWizard;
export const selectPermTemplate = (state: PermissionStates) => state.permissions.permWizard.selectedPermTemplate;
export const selectPermWizardLine = (state: PermissionStates) => state.permissions.permWizard.selectedPermWizardLine;

export const selectUpdatePermWizardListing = (state: PermissionStates) => state.permissions.permWizard.updatePermWizardListing;

export const selectGuid = (state: PermissionStates) => state.permissions.permWizard.selectedGuid;
export const selectViewCache = (state: PermissionStates) => state.permissions.permWizard.viewCache;
export const selectRequiresUpdate = (state: PermissionStates) => state.permissions.permWizard.requiresUpdate;


// This is an example of how to combine selectors
// export const combinedSelectors = createSelector(
//   selectGuid,
//   selectRemoveState,
//   (guid, onRemove) => ({guid, onRemove})
// )

export const {
    selectIds,
    selectEntities,
    selectAll,
    selectTotal
} = permWizardAdapters.getSelectors(selectPermWizardFeature);
